import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import type { ApiGetDataStatus, CouponStateType } from '@redux/types'
import { CouponType } from '@schemas'

const initialState: CouponStateType = {
	couponList: [],
	couponListStatus: 'init',
	updateCoupon: {
		couponId: '',
		name: '',
		email: '',
		discountUsd: 0,
		discountKrw: 0,
		quantity: 0,
		expiredAt: '',
		useYn: 0,
		iudFlag: 'I',
		unitUsd: 0,
		unitKrw: 0,
	},
	triggerInitCoupon: false,
}

const slice = createSlice({
	name: 'coupon',
	initialState,
	reducers: {
		// trigger
		TRIGGER_INIT_COUPON_PAGE: (
			state: CouponStateType,
			action: PayloadAction<boolean>,
		) => {
			state.triggerInitCoupon = action.payload
		},

		// coupons
		COUPON_LIST: (state: CouponStateType, action: PayloadAction<CouponType[]>) => {
			state.couponList = action.payload
		},
		COUPON_LIST_STATUS: (
			state: CouponStateType,
			action: PayloadAction<ApiGetDataStatus>,
		) => {
			state.couponListStatus = action.payload
		},

		// updateCoupon
		UPDATE_COUPON: (
			state: CouponStateType,
			action: PayloadAction<CouponStateType['updateCoupon']>,
		) => {
			state.updateCoupon = action.payload
		},
	},
})

export const couponActions = slice.actions
export default slice.reducer
